// extracted by mini-css-extract-plugin
module.exports = {"outerOrderDiv":"OrderCard_outerOrderDiv__TlWfG","event_title":"OrderCard_event_title__yONQ3"};